<template>
    <div class="w-64 bg-white border-r border-gray-200 flex flex-col">
        <div class="p-4 border-b border-gray-200">
            <div class="text-2xl font-['Pacifico'] text-primary">
                <img :src="logoUrl" alt="logo"/>
            </div>
        </div>
        <nav class="flex-1 overflow-y-auto">
            <div class="px-4 py-2 text-sm font-medium text-gray-600">功能导航</div>
            
            <!-- 1. 小助手 -->
            <router-link to="/chat" class="sidebar-item flex items-center px-4 py-3" active-class="active">
                <i class="fas fa-robot w-5 h-5 text-gray-600"></i>
                <span class="ml-3">小助手</span>
            </router-link>
            
            <!-- 2. 历史记录 -->
            <router-link v-if="false" to="/history-conversations" class="sidebar-item flex items-center px-4 py-3" active-class="active">
                <i class="fas fa-history w-5 h-5 text-gray-600"></i>
                <span class="ml-3">历史记录</span>
            </router-link>
            
            <!-- 3. 收藏夹 -->
            <router-link to="/favorites" class="sidebar-item flex items-center px-4 py-3" active-class="active">
                <i class="fas fa-star w-5 h-5 text-gray-600"></i>
                <span class="ml-3">收藏夹</span>
                <span v-if="favoriteCount > 0" class="ml-auto bg-yellow-100 text-yellow-800 text-xs px-2 py-1 rounded-full">
                    {{ favoriteCount }}
                </span>
            </router-link>
            
            <!-- 4. 知识库模块 - 需要权限控制 -->
            <router-link 
                v-if="canAccessKnowledge" 
                to="/knowledge" 
                class="sidebar-item flex items-center px-4 py-3" 
                active-class="active"
            >
                <i class="fas fa-book w-5 h-5 text-gray-600"></i>
                <span class="ml-3">知识库</span>
            </router-link>
            
            <!-- 5. 用户管理模块 - 管理员和用户管理员可见 -->
            <router-link 
                v-if="canAccessUserManagement" 
                to="/users" 
                class="sidebar-item flex items-center px-4 py-3" 
                active-class="active"
            >
                <i class="fas fa-users-cog w-5 h-5 text-gray-600"></i>
                <span class="ml-3">用户管理</span>
            </router-link>
            
            <!-- 6. 相关问题管理模块 - 仅管理员可见 -->
            <router-link 
                v-if="canAccessAdmin" 
                to="/related-questions" 
                class="sidebar-item flex items-center px-4 py-3" 
                active-class="active"
            >
                <i class="fas fa-question-circle w-5 h-5 text-gray-600"></i>
                <span class="ml-3">相关问题管理</span>
            </router-link>
            
            <!-- 7. 问题反馈模块 - 所有用户可见 -->
            <router-link 
                to="/feedback" 
                class="sidebar-item flex items-center px-4 py-3" 
                active-class="active"
            >
                <i class="fas fa-comment-dots w-5 h-5 text-gray-600"></i>
                <span class="ml-3">问题反馈</span>
                <span v-if="unrepliedFeedbackCount > 0" class="ml-auto bg-red-100 text-red-800 text-xs px-2 py-1 rounded-full">
                    {{ unrepliedFeedbackCount }}
                </span>
            </router-link>
        </nav>
                 <div class="p-4 border-t border-gray-200">
             <div class="flex items-center justify-between">
                 <div class="flex items-center">
                     <div class="font-medium text-gray-800 text-lg">{{ currentDisplayName }}</div>
                 </div>
                <div class="flex space-x-2">
                                         <button 
                         @click="openChangePasswordModal"
                         class="p-2 text-gray-500 hover:text-blue-500 hover:bg-blue-50 rounded-lg transition-colors duration-200"
                         title="修改密码"
                     >
                         <i class="fas fa-key"></i>
                     </button>
                    <button 
                        @click="logout" 
                        class="p-2 text-gray-500 hover:text-red-500 hover:bg-red-50 rounded-lg transition-colors duration-200"
                        title="退出登录"
                    >
                        <i class="fas fa-sign-out-alt"></i>
                    </button>
                </div>
            </div>
        </div>
        
        <!-- 修改密码弹窗 -->
        <div v-if="showChangePasswordModal" class="fixed inset-0 flex items-center justify-center z-50">
            <!-- 背景遮罩 -->
            <div class="absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm"></div>
            
            <!-- 弹窗容器 -->
            <div class="relative bg-white rounded-2xl p-8 w-[500px] max-w-[90vw] shadow-2xl">
                <!-- 弹窗头部 -->
                <div class="text-center mb-8">
                    <div class="w-16 h-16 bg-gradient-to-br from-orange-400 to-red-500 rounded-full flex items-center justify-center mx-auto mb-4">
                        <i class="fas fa-key text-white text-2xl"></i>
                    </div>
                                         <h3 class="text-2xl font-bold text-gray-900 mb-2">修改密码和用户名</h3>
                     <p class="text-gray-600">请确保新密码和用户名符合安全要求</p>
                </div>
                
                <form @submit.prevent="changePassword" class="space-y-6">
                    <!-- 原密码 -->
                    <div class="form-group">
                        <label class="block text-sm font-semibold text-gray-700 mb-2">原密码</label>
                        <div class="relative">
                            <div class="input-icon">
                                <i class="fas fa-lock"></i>
                            </div>
                            <input 
                                v-model="passwordForm.oldPassword"
                                :type="showOldPassword ? 'text' : 'password'"
                                required
                                class="form-input"
                                placeholder="请输入原密码"
                            />
                            <div class="password-toggle" @click="showOldPassword = !showOldPassword">
                                <i :class="showOldPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                            </div>
                        </div>
                    </div>
                    
                    <!-- 新密码 -->
                    <div class="form-group">
                        <label class="block text-sm font-semibold text-gray-700 mb-2">新密码</label>
                        <div class="relative">
                            <div class="input-icon">
                                <i class="fas fa-lock"></i>
                            </div>
                            <input 
                                v-model="passwordForm.newPassword"
                                :type="showNewPassword ? 'text' : 'password'"
                                required
                                class="form-input"
                                placeholder="请输入新密码"
                                @input="checkPasswordStrength"
                            />
                            <div class="password-toggle" @click="showNewPassword = !showNewPassword">
                                <i :class="showNewPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                            </div>
                        </div>
                        
                        <!-- 密码复杂度提示 -->
                        <div class="password-strength" v-if="passwordForm.newPassword">
                            <div class="flex items-center justify-between mb-3">
                                <span class="text-sm font-medium text-gray-700">密码强度</span>
                                <span class="text-sm" :class="passwordStrengthClass === 'strong' ? 'text-green-600' : passwordStrengthClass === 'medium' ? 'text-yellow-600' : 'text-red-600'">
                                    {{ passwordStrengthText }}
                                </span>
                            </div>
                            <div class="strength-bar">
                                <div class="strength-fill" :class="passwordStrengthClass"></div>
                            </div>
                            <div class="complexity-requirements">
                                <div class="requirement" :class="{ met: passwordForm.newPassword.length >= 6 }">
                                    <i :class="passwordForm.newPassword.length >= 6 ? 'fas fa-check-circle' : 'fas fa-times-circle'"></i>
                                    至少6位
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- 确认新密码 -->
                    <div class="form-group">
                        <label class="block text-sm font-semibold text-gray-700 mb-2">确认新密码</label>
                        <div class="relative">
                            <div class="input-icon">
                                <i class="fas fa-lock"></i>
                            </div>
                            <input 
                                v-model="passwordForm.confirmPassword"
                                :type="showConfirmPassword ? 'text' : 'password'"
                                required
                                class="form-input"
                                placeholder="请再次输入新密码"
                            />
                            <div class="password-toggle" @click="showConfirmPassword = !showConfirmPassword">
                                <i :class="showConfirmPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                            </div>
                        </div>
                                         </div>
                     
                     <!-- 修改用户名 -->
                     <div class="form-group">
                         <label class="block text-sm font-semibold text-gray-700 mb-2">修改用户名</label>
                         <div class="relative">
                             <div class="input-icon">
                                 <i class="fas fa-user-circle"></i>
                             </div>
                             <input 
                                 v-model="passwordForm.newDisplayName"
                                 type="text"
                                 required
                                 class="form-input"
                                 :placeholder="`当前用户名：${currentDisplayName}`"
                             />
                         </div>
                     </div>
                     
                     <!-- 消息提示 -->
                    <div v-if="passwordMessage" class="message-box" :class="passwordMessageType === 'success' ? 'success-message' : 'error-message'">
                        <div class="flex items-center space-x-2">
                            <i :class="passwordMessageType === 'success' ? 'fas fa-check-circle' : 'fas fa-exclamation-circle'"></i>
                            <span>{{ passwordMessage }}</span>
                        </div>
                    </div>
                    
                    <!-- 操作按钮 -->
                    <div class="flex space-x-4 pt-4">
                        <button 
                            type="submit"
                            :disabled="isChangingPassword"
                            class="submit-button"
                        >
                            <span v-if="isChangingPassword">
                                <i class="fas fa-spinner fa-spin mr-2"></i>修改中...
                            </span>
                            <span v-else>
                                <i class="fas fa-check mr-2"></i>确认修改
                            </span>
                        </button>
                                                 <button 
                             type="button"
                             @click="closeChangePasswordModal"
                             class="cancel-button"
                         >
                             取消
                         </button>
                    </div>
                </form>
                
                                 <!-- 关闭按钮 -->
                 <button 
                     @click="closeChangePasswordModal"
                     class="absolute top-4 right-4 w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors duration-200"
                 >
                     <i class="fas fa-times text-gray-600"></i>
                 </button>
            </div>
        </div>
    </div>
</template>
<style scoped>
/* 侧边栏导航项样式 */
.sidebar-item {
    text-decoration: none;
    color: #6b7280;
    transition: all 0.3s ease;
    border-radius: 8px;
    margin: 2px 8px;
}

.sidebar-item:hover {
    background-color: #f3f4f6;
    color: #374151;
}

.sidebar-item.active {
    background-color: #c03333;
    color: white;
}

.sidebar-item.active i {
    color: white !important;
}

/* 修改密码弹窗样式 - 与登录注册页面保持一致 */
.form-group {
    position: relative;
    margin-bottom: 20px;
}

.input-icon {
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translateY(-50%);
    color: #95a5a6;
    z-index: 2;
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    line-height: 1;
    pointer-events: none;
    user-select: none;
    background: transparent;
}

.form-input {
    width: 100%;
    padding: 15px 15px 15px 45px;
    border: 2px solid #ecf0f1;
    border-radius: 10px;
    font-size: 16px;
    transition: all 0.3s ease;
    box-sizing: border-box;
    line-height: 1.5;
    height: 50px;
}

/* 为密码输入框添加右侧padding，避免文字与眼睛图标重叠 */
.form-input[type="password"] {
    padding-right: 50px;
}

.form-input:focus {
    outline: none;
    border-color: #c03333;
    box-shadow: 0 0 0 3px rgba(192, 51, 51, 0.1);
}

.password-toggle {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    color: #95a5a6;
    cursor: pointer;
    z-index: 2;
    transition: color 0.3s ease;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    pointer-events: auto;
}

.password-toggle:hover {
    color: #c03333;
}

/* 确保眼睛图标不会重复显示 */
.password-toggle i {
    position: relative;
    z-index: 1;
    font-size: 16px;
    line-height: 1;
}

/* 优化图标对齐 */
.input-icon i,
.password-toggle i {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* 密码强度样式 */
.password-strength {
    margin-top: 10px;
    padding: 15px;
    background: #f8f9fa;
    border-radius: 8px;
    border: 1px solid #e9ecef;
}

/* 密码强度文本样式优化 */
.password-strength .text-sm {
    font-size: 14px !important;
    font-weight: 500 !important;
}

.strength-bar {
    height: 6px;
    background: #e9ecef;
    border-radius: 3px;
    overflow: hidden;
    margin-bottom: 8px;
}

.strength-fill {
    height: 100%;
    transition: all 0.3s ease;
    border-radius: 3px;
}

.strength-fill.weak {
    width: 25%;
    background: #dc3545;
}

.strength-fill.medium {
    width: 50%;
    background: #ffc107;
}

.strength-fill.strong {
    width: 100%;
    background: #28a745;
}

.complexity-requirements {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
}

.requirement {
    display: flex;
    align-items: center;
    font-size: 13px;
    color: #6c757d;
    transition: color 0.3s ease;
    font-weight: 500;
}

.requirement.met {
    color: #28a745;
}

.requirement i {
    margin-right: 6px;
    font-size: 12px;
}

.requirement.met i {
    color: #28a745;
}

.requirement:not(.met) i {
    color: #dc3545;
}

/* 消息提示样式 */
.message-box {
    padding: 10px;
    border-radius: 8px;
    font-size: 14px;
    border: 1px solid;
}

.success-message {
    background: rgba(39, 174, 96, 0.1);
    color: #27ae60;
    border-color: rgba(39, 174, 96, 0.2);
}

.error-message {
    background: rgba(231, 76, 60, 0.1);
    color: #e74c3c;
    border-color: rgba(231, 76, 60, 0.2);
}

/* 按钮样式 */
.submit-button {
    flex: 1;
    background: #c03333;
    color: white;
    border: none;
    padding: 15px;
    border-radius: 10px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
}

.submit-button:hover:not(:disabled) {
    background: #ff3742;
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(255, 71, 87, 0.3);
}

.submit-button:disabled {
    background: #bdc3c7;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
}

.cancel-button {
    flex: 1;
    background: #ecf0f1;
    color: #7f8c8d;
    border: none;
    padding: 15px;
    border-radius: 10px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
}

.cancel-button:hover {
    background: #d5dbdb;
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(213, 219, 219, 0.3);
}
</style>
<script>
import logo from '@/assets/imgs/logo.png'
import headerLogo from '@/assets/imgs/ic.jpg'
import apiConfig from '@/config/api'

export default {
    data() {
        return {
            logoUrl: logo,
            headerLogo: headerLogo,
            currentDisplayName: '',
            userPermissions: {
                knowledgeAccess: false,
                userManagementAccess: false
            },
            favoriteCount: 0,
            unrepliedFeedbackCount: 0,
            showChangePasswordModal: false,
            isChangingPassword: false,
            passwordForm: {
                oldPassword: '',
                newPassword: '',
                confirmPassword: '',
                newDisplayName: ''
            },
            passwordMessage: '',
            passwordMessageType: 'success',
            showOldPassword: false,
            showNewPassword: false,
            showConfirmPassword: false,
            passwordStrengthClass: 'weak',
            passwordStrengthText: '密码强度：弱'
        };
    },
    computed: {
        isAdmin() {
            // 从localStorage获取用户角色信息
            const userRole = localStorage.getItem('userRole');
            return userRole === 'admin';
        },
        canAccessKnowledge() {
            // 管理员默认有权限，普通用户需要授权
            return this.isAdmin || this.userPermissions.knowledgeAccess;
        },
        canAccessUserManagement() {
            // 管理员和用户管理员可以访问用户管理
            const userRole = localStorage.getItem('userRole');
            return userRole === 'admin' || userRole === 'user_manager';
        },
        canAccessAdmin() {
            // 只有管理员可以访问相关问题管理
            const userRole = localStorage.getItem('userRole');
            return userRole === 'admin';
        }
    },
    mounted() {
        this.loadUserInfo();
        this.loadUserPermissions();
        this.loadFavoriteCount();
        this.loadUnrepliedFeedbackCount();
        
        // 监听localStorage变化，用于更新收藏数量
        window.addEventListener('storage', this.handleStorageChange);
        // 监听自定义事件（用于同页面内的变化）
        window.addEventListener('favoriteCountUpdated', this.loadFavoriteCount);
        window.addEventListener('feedbackCountUpdated', this.loadUnrepliedFeedbackCount);
    },
    beforeDestroy() {
        // 清理事件监听器
        window.removeEventListener('storage', this.handleStorageChange);
        window.removeEventListener('favoriteCountUpdated', this.loadFavoriteCount);
        window.removeEventListener('feedbackCountUpdated', this.loadUnrepliedFeedbackCount);
    },
    methods: {
        loadUserInfo() {
            const displayName = localStorage.getItem('displayName');
            if (displayName) {
                this.currentDisplayName = displayName;
            } else {
                this.currentDisplayName = '未登录';
            }
        },
        
        
        async loadUserPermissions() {
            try {
                const token = localStorage.getItem('token');
                if (!token) return;
                
                const response = await fetch(`${apiConfig.baseURL}/api/auth/current-user`, {
                    headers: {
                        'Authorization': token
                    }
                });
                
                if (response.ok) {
                    const result = await response.json();
                    if (result.code === 200 && result.data) {
                        this.userPermissions = {
                            knowledgeAccess: result.data.knowledgeAccess || false,
                            userManagementAccess: result.data.userManagementAccess || false
                        };
                    }
                }
            } catch (error) {
                console.error('加载用户权限失败:', error);
            }
        },
        
        openChangePasswordModal() {
            // 在打开弹窗时，将当前用户名填充到表单中
            this.passwordForm.newDisplayName = this.currentDisplayName;
            this.showChangePasswordModal = true;
        },
        
        closeChangePasswordModal() {
            this.showChangePasswordModal = false;
            // 重置表单
            this.passwordForm = {
                oldPassword: '',
                newPassword: '',
                confirmPassword: '',
                newDisplayName: ''
            };
            this.passwordMessage = '';
        },
        logout() {
            // 清除本地存储的登录信息
            localStorage.removeItem('token');
            localStorage.removeItem('sessionId');
            localStorage.removeItem('loginAccount');
            localStorage.removeItem('displayName');
            localStorage.removeItem('userRole');
            localStorage.removeItem('userId');
            
            // 跳转到登录页面，避免重复导航
            if (this.$route.path !== '/login') {
                this.$router.push('/login');
            }
        },
        
        async changePassword() {
            // 验证表单
            if (!this.passwordForm.oldPassword || !this.passwordForm.newPassword || !this.passwordForm.confirmPassword) {
                this.showPasswordMessage('请填写所有密码字段', 'error');
                return;
            }
            
            if (this.passwordForm.newPassword.length < 6) {
                this.showPasswordMessage('新密码长度不能少于6位', 'error');
                return;
            }
            
            if (this.passwordForm.newPassword !== this.passwordForm.confirmPassword) {
                this.showPasswordMessage('两次输入的新密码不一致', 'error');
                return;
            }
            
            // 验证新用户名
            if (this.passwordForm.newDisplayName && this.passwordForm.newDisplayName.trim().length < 2) {
                this.showPasswordMessage('新用户名长度不能少于2个字符', 'error');
                return;
            }
            
            this.isChangingPassword = true;
            this.passwordMessage = '';
            
            try {
                const token = localStorage.getItem('token');
                if (!token) {
                    this.showPasswordMessage('用户未登录，请重新登录', 'error');
                    return;
                }
                
                                 const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/api/auth/change-password`, {
                     method: 'POST',
                     headers: {
                         'Content-Type': 'application/json',
                         'Authorization': token
                     },
                                           body: JSON.stringify({
                          oldPassword: this.passwordForm.oldPassword,
                          newPassword: this.passwordForm.newPassword,
                          confirmPassword: this.passwordForm.confirmPassword,
                          newDisplayName: this.passwordForm.newDisplayName
                      })
                 });
                
                const result = await response.json();
                
                if (response.ok && result.success) {
                    this.showPasswordMessage(result.message, 'success');
                    
                    // 更新localStorage和显示的用户名
                    if (result.currentDisplayName) {
                        localStorage.setItem('displayName', result.currentDisplayName);
                        this.currentDisplayName = result.currentDisplayName;
                    }
                    
                    // 清空表单
                    this.passwordForm = {
                        oldPassword: '',
                        newPassword: '',
                        confirmPassword: '',
                        newDisplayName: ''
                    };
                    // 3秒后关闭弹窗
                    setTimeout(() => {
                        this.showChangePasswordModal = false;
                        this.passwordMessage = '';
                    }, 3000);
                } else {
                    this.showPasswordMessage(result.message, 'error');
                }
            } catch (error) {
                console.error('修改密码失败:', error);
                this.showPasswordMessage('网络错误，请稍后重试', 'error');
            } finally {
                this.isChangingPassword = false;
            }
        },
        
        showPasswordMessage(message, type) {
            this.passwordMessage = message;
            this.passwordMessageType = type;
        },
        
        checkPasswordStrength() {
            const password = this.passwordForm.newPassword;
            
            // 检查密码长度
            const hasLength = password.length >= 6;
            
            // 计算密码强度
            let strength = 0;
            if (hasLength) strength++;
            
            // 如果密码长度足够，根据长度和复杂度进一步评估
            if (hasLength) {
                if (password.length >= 8) {
                    strength += 2; // 8位以上加分
                } else if (password.length >= 6) {
                    strength += 1; // 6-7位
                }
                
                // 检查是否包含数字和字母
                if (/\d/.test(password) && /[a-zA-Z]/.test(password)) {
                    strength += 1; // 包含数字和字母加分
                }
            }
            
            // 设置密码强度样式和文本
            if (strength >= 3) {
                this.passwordStrengthClass = 'strong';
                this.passwordStrengthText = '密码强度：强';
            } else if (strength >= 2) {
                this.passwordStrengthClass = 'medium';
                this.passwordStrengthText = '密码强度：中';
            } else {
                this.passwordStrengthClass = 'weak';
                this.passwordStrengthText = '密码强度：弱';
            }
        },

        // 加载收藏数量
        async loadFavoriteCount() {
            try {
                const token = localStorage.getItem('token');
                if (!token) {
                    return;
                }

                const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/api/favorites/list?page=0&size=1`, {
                    headers: {
                        'Authorization': token
                    }
                });

                const result = await response.json();
                if (result.code === 200) {
                    this.favoriteCount = result.data.totalCount || 0;
                }
            } catch (error) {
                console.error('加载收藏数量失败:', error);
                // 静默失败，不影响其他功能
            }
        },

        // 处理localStorage变化
        handleStorageChange(event) {
            if (event.key === 'favoriteCountUpdated') {
                console.log('检测到收藏数量变化，重新加载');
                this.loadFavoriteCount();
            }
        },

        // 加载未回复反馈数量
        async loadUnrepliedFeedbackCount() {
            try {
                const token = localStorage.getItem('token');
                if (!token) {
                    this.unrepliedFeedbackCount = 0;
                    return;
                }

                const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/api/feedback/unreplied-count`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });

                const result = await response.json();
                if (result.code === 200) {
                    this.unrepliedFeedbackCount = result.data.totalUnreplied || 0;
                } else {
                    this.unrepliedFeedbackCount = 0;
                }
            } catch (error) {
                console.error('加载未回复反馈数量失败:', error);
                this.unrepliedFeedbackCount = 0;
            }
        }
    }
};
</script>